import React from "react";
import { ROLE_PM, ROLE_TENANT } from "../../context/RoleContext";

// Same purple used on the marketing site (landing.scss --p-purple-deep).
const PORCHER_PURPLE = "#6d28d9";

/** Segmented Tenant / Property Manager selector — determines which role a user signs in/up as. */
const RoleToggle = ({ role, onChange }) => (
  <div className="d-flex rounded overflow-hidden border mb-3" style={{ height: 56 }}>
    <button
      type="button"
      className="flex-fill border-0 text-center px-2"
      style={{
        background: role === ROLE_TENANT ? PORCHER_PURPLE : "#fff",
        color: role === ROLE_TENANT ? "#fff" : "#1e2233",
      }}
      onClick={() => onChange(ROLE_TENANT)}
    >
      <span className="d-block fw-semibold">Tenant</span>
      <span className="d-block" style={{ fontSize: "0.72rem", opacity: role === ROLE_TENANT ? 0.85 : 0.65 }}>
        Pay rent and manage applications
      </span>
    </button>
    <button
      type="button"
      className="flex-fill border-0 border-start text-center px-2"
      style={{
        background: role === ROLE_PM ? PORCHER_PURPLE : "#fff",
        color: role === ROLE_PM ? "#fff" : "#1e2233",
      }}
      onClick={() => onChange(ROLE_PM)}
    >
      <span className="d-block fw-semibold">Property Manager</span>
      <span className="d-block" style={{ fontSize: "0.72rem", opacity: role === ROLE_PM ? 0.85 : 0.65 }}>
        Manage your property rentals
      </span>
    </button>
  </div>
);

export default RoleToggle;
